import { Box, Typography, useTheme } from '@mui/material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import { VodSearchItem } from './SearchVodItem'
import { ShowMoreButton } from '@/shared/ui/ShowMoreButton'
import { SearchResultType } from '@/types/search/searchResultType'

interface IVodSearchResults {
    vodItemsSet: SearchResultType[]
    showMore: boolean
    setShowMore: Dispatch<SetStateAction<boolean>>
    onItemClick?: () => void
}

export const VodSearchResults = ({
    vodItemsSet,
    showMore,
    setShowMore,
    onItemClick,
}: IVodSearchResults) => {
    const { t: translate } = useTranslation()
    const theme = useTheme()

    const shortenChannelsSet =
        !showMore && vodItemsSet.length > 3
            ? vodItemsSet.slice(0, 3)
            : vodItemsSet

    const noResultsInfoStyle = {
        marginTop: '50px',
        textAlign: 'center',
        width: '100vw',
        typography: 'text3',
        color: 'white',
        maxWidth: { xs: 'unset', lg: '440px' },
    }

    const channelsListStyle = {
        marginTop: '17px',
        width: { xs: 'calc(100% - 16px)', lg: '100%' },
        margin: 'auto',
        maxWidth: '100%',
        position: 'relative',
        overflow: 'auto',
        overflowX: 'hidden',
        padding: 0,
        '& ul': { padding: 0 },
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px',
    }

    const listItem = {
        padding: '0',
        justifyContent: 'center',
        breakInside: 'avoid',
        maxWidth: showMore ? '300px' : 'unset',
        minHeight: showMore ? '100px' : 'unset',
        display: 'block',
    }

    const VodItemsToDisplay = shortenChannelsSet.map(
        (item: SearchResultType) => (
            <ListItem key={item.internalDeepLinkContentId} sx={listItem}>
                <VodSearchItem item={item} />
            </ListItem>
        )
    )

    return (
        <Box onClick={onItemClick}>
            <Typography
                color="white"
                variant="subtitle1"
                pb="16px"
                borderBottom={`1px solid ${theme.palette.custom.border}`}>
                VOD: {vodItemsSet.length}
            </Typography>
            <Box mt="16px">
                {VodItemsToDisplay.length ? (
                    <>
                        <List sx={channelsListStyle}>{VodItemsToDisplay}</List>
                        <ShowMoreButton
                            setShowMore={setShowMore}
                            showMore={showMore}
                        />
                    </>
                ) : (
                    <Typography sx={noResultsInfoStyle}>
                        {vodItemsSet.length
                            ? translate('lackOfSearchResults')
                            : 'no VOD was found'}
                    </Typography>
                )}
            </Box>
        </Box>
    )
}
